













import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation, Getter } from 'vuex-class';
import { DatePicker} from '@/features/reports/services';
import { SET_REPORTING_DATE_RANGE } from '@/store/reports/mutationTypes';
import { DateOption } from '@/features/reports/models';
import CalendarIcon from 'vue-material-design-icons/CalendarRange.vue';

@Component({
	components: { CalendarIcon }
})
export default class UsageDateRangeFilter extends Vue {
	@Mutation(SET_REPORTING_DATE_RANGE) public setReportingDateRange: (dateOption: DateOption) => void;
	@Getter public selectedDateOption: DateOption;
	@Getter public isReportLoading: boolean;

	public value: DateOption = DatePicker.monthOptions.thisMonth;

	public mounted() {
		this.value = this.findMatchingValue(this.selectedDateOption) ?? DatePicker.options.thisMonth;
	}

	@Watch('value')
	public selectRange(newValue: DateOption) {
		this.setReportingDateRange(newValue);
	}

	public findMatchingValue(value: DateOption): DateOption | undefined {
		return this.dateOptions.find(option =>
			option.getDateRange().start.getTime() === value.getDateRange().start.getTime() &&
			option.getDateRange().end.getTime() === value.getDateRange().end.getTime());
	}

	public get dateOptions(): DateOption[] {
		return DatePicker.monthOptions.toArray().filter(m => {
			return m.getDateRange().end.getFullYear() > 2021;
		}).sort((a, b) => {
			const aIsNumeric = !isNaN(parseInt(a.label, 10));
			const bIsNumeric = !isNaN(parseInt(b.label, 10));
			if (aIsNumeric && bIsNumeric) {
				return parseInt(b.label, 10) - parseInt(a.label, 10);
			}
			if (aIsNumeric || bIsNumeric) {
				return -1;
			}
			return 0;
		});
	}
}
